import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import RequirableControlLabel from '../RequirableControlLabel/RequirableControlLabel';
import './DateFormGroup.css';

const isError = (error, touched) => (error && touched ? 'error' : null);

// eslint-disable-next-line object-curly-newline
const DateFormGroup = ({ label, meta, input, required, ...props }) => (
  <FormGroup validationState={isError(meta.error, meta.touched)} >
    {label && <RequirableControlLabel required={required} >{label}</RequirableControlLabel> }
    <DatePicker {...input} {...props} bsSize="large" />
    <FormControl.Feedback />
    {(meta.touched && meta.error) && <HelpBlock>{meta.error}</HelpBlock> }
  </FormGroup>
);

DateFormGroup.defaultProps = {
  label: '',
  meta: {},
  input: {},
  required: false,
};

DateFormGroup.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  meta: PropTypes.shape({}),
  input: PropTypes.shape({}),
};

export default DateFormGroup;



// WEBPACK FOOTER //
// ./src/components/Forms/DateFormGroup/DateFormGroup.jsx